import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { Endpoints } from '@/api';
import { useFetch } from '@/utils/fetch';

export type DeliveryOption = 'store' | 'home' | 'pickupPoint_mondialRelay';

export const useClientShippingOptions = ({
  requestId,
  enabled = true,
}: {
  requestId: string;
  enabled?: boolean;
}) => {
  const fetch = useFetch<Endpoints['GET /requests/:id/client/shipping-options']>();

  return useQuery({
    queryKey: ['request', requestId, 'client', 'shipping-options'],
    queryFn: () => fetch(`/requests/${requestId}/client/shipping-options`),
    placeholderData: keepPreviousData,
    enabled,
  });
};

export type ClientFromGetMany = Endpoints['GET /clients']['response']['clients'][number];

export const useClients = (params: {
  code?: string;
  firstName?: string;
  lastName?: string;
  postalCode?: string;
  limit?: number;
  offset?: number;
}) => {
  const fetch = useFetch<Endpoints['GET /clients']>();

  return useQuery({
    queryKey: ['clients', params],
    queryFn: () => fetch('/clients', params),
    placeholderData: keepPreviousData,
  });
};

export const useClientPurchaseHistory = ({
  clientId,
  clientExternalId,
  enabled,
}: {
  clientId: string | undefined | null;
  clientExternalId: string | undefined | null;
  enabled: boolean;
}) => {
  const fetch = useFetch<Endpoints['GET /clients/:clientId/purchase-history']>();

  return useQuery({
    queryKey: ['clients', 'purchase-history', clientId, clientExternalId],
    queryFn: () => fetch(`/clients/${clientId}/purchase-history`),
    enabled: !!clientId && !!clientExternalId && enabled,
  });
};
